class SiteUI{

    constructor(){

    }

    show(){

        document.body.style.opacity = "1";
        
    }


}

export default SiteUI;